import React, { useEffect, useRef, useState } from "react";
import { Chart, registerables } from "chart.js";
import "../styles/AnalyticsSection.css";
import { useNavigate } from "react-router-dom";
Chart.register(...registerables);
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; 
export default function AnalyticsSection() {
  const trendChartRef = useRef(null);
  const modalityChartRef = useRef(null);
  const navigate = useNavigate();
  const trendInstance = useRef(null);
  const modalityInstance = useRef(null);
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("access_token");
      const response = await fetch(
        `${API_BASE_URL}/api/dashboard_data/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch dashboard");
      }
      const data = await response.json();
      setDashboard(data);
    } catch (error) {
      console.error("Dashboard Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      !dashboard ||
      !trendChartRef.current ||
      !modalityChartRef.current
    ) {
      return;
    }
    trendInstance.current?.destroy();
    modalityInstance.current?.destroy();
    trendInstance.current = new Chart(trendChartRef.current, {
      type: "line",
      data: {
        labels: dashboard.trend?.map((item) => item.label) || [],
        datasets: [
          {
            label: "Studies",
            data: dashboard.trend?.map((item) => item.count) || [],
            borderColor: "#2563eb",
            backgroundColor: "rgba(37,99,235,0.15)",
            fill: true,
            tension: 0.4,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
    });
  
    modalityInstance.current = new Chart(modalityChartRef.current, {
      type: "doughnut",
      data: {
        labels: dashboard.modality?.map((item) => item.name) || [],
        datasets: [
          {
            data: dashboard.modality?.map((item) => item.count) || [],
            backgroundColor: ["#2563eb", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4"],
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
    });
  
    return () => {
      trendInstance.current?.destroy();
      modalityInstance.current?.destroy();
    };
  }, [dashboard]);

  if (loading) {
    return (
      <div className="dashboard-loading">
        Loading dashboard...
      </div>
    );
  }

  if (!dashboard) {
    return (
      <div className="dashboard-loading">
        Failed to load dashboard.
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div>
          <h2>🏥 Dashboard</h2>
          <p>Welcome to your PACS Analytics Dashboard</p>
        </div>
        <div className="dashboard-actions">
        </div>
      </div>
      <div className="cards-grid">
        <div className="dashboard-card">
          <span>Total Patients</span>
          <h2>{dashboard.cards.totalPatients}</h2>
        </div>
  
        <div className="dashboard-card">
          <span>Today's Studies</span>
          <h2>{dashboard.cards.todayStudies}</h2>
        </div>
  
        <div className="dashboard-card">
          <span>Completed Reports</span>
          <h2>{dashboard.cards.completedReports}</h2>
        </div>
  
        <div className="dashboard-card">
          <span>Pending Reports</span>
          <h2>{dashboard.cards.pendingReports}</h2>
        </div>
  
        <div className="dashboard-card">
          <span>Total Doctors</span>
          <h2>{dashboard.cards.totalDoctors}</h2>
        </div>
  
        <div className="dashboard-card">
          <span>Storage Used</span>
          <h2>{dashboard.cards.storageUsed}%</h2>
        </div>
  
      </div>
      <div className="charts-row">
        <div className="chart-box">
          <h3>Study Upload Trend</h3>
          <div style={{ height: "320px" }}>
            <canvas ref={trendChartRef}></canvas>
          </div>
        </div>
        <div className="chart-box">
          <h3>Study Modality Distribution</h3>
          <div style={{ height: "320px" }}>
            <canvas ref={modalityChartRef}></canvas>
          </div>
        </div>
      </div>
      <div className="recent-card">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "15px",
          }}
        >
          <h3>Recent Studies</h3>
  
          <button
            className="upload-btn"
            onClick={() => navigate("/patient")}
          >
            View All
          </button>
        </div>
        <table>
          <thead>
            <tr>
              <th>Patient</th>
              <th>UHID</th>
              <th>Modality</th>
              <th>Doctor</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {dashboard.recentStudies?.length > 0 ? (
              dashboard.recentStudies.map((study) => (
                <tr key={study.id}>
                  <td>{study.patient}</td>
                  <td>{study.uhid}</td>
                  <td>{study.modality}</td>
                  <td>{study.doctor}</td>
                  <td><span className={`status ${study.status.toLowerCase()}`}>{study.status}</span></td>
                  <td>{study.date}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  style={{
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  No recent studies available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}